module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiCnIt.7e13756.eot";